import api from "./axios";


// Helper function to extract error message from API response
export const errorMessage = (error) => {
  if (error && error.response && error.response.data) {
    if (error.response.data.message) {
      return error.response.data.message;
    }
    if (
      error.response.data.errors &&
      Array.isArray(error.response.data.errors)
    ) {
      return error.response.data.errors[0];
    }
    if (
      error.response.data.errors &&
      typeof error.response.data.errors === "object"
    ) {
      const firstError = Object.values(error.response.data.errors)[0];
      if (Array.isArray(firstError)) {
        return firstError[0];
      }
      return String(firstError);
    }
  }
  return error?.message || "An unexpected error occurred";
};


// Clients API service
export const dashboardApi = {
  // Get all clients
  getDashboardData: async () => {
    try {
      const response = await api.get(`/dashboard/data`);
      return response.data;
    } catch (error) {
      return { error: errorMessage(error) };
    }
  },
 
  getDashboardChartAndCardData: async (data) => {
    try {
      const response = await api.post(`/dashboard/chartData`, data);
      return response.data;
    } catch (error) {
      return { error: errorMessage(error) };
    }
  },
 
};

export default dashboardApi;
